import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ProductManagement = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');  // Changed from categoryId to category
  const [details, setDetails] = useState('');
  const [Therapy, setTherapy] = useState('');
  const [Form, setForm] = useState('');
  const [Benefits, setBenefits] = useState('');
  const [Packing, setPacking] = useState('');
  const [Dosage, setDosage] = useState('');
  const [Disclaimer, setDisclaimer] = useState('');

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState('');
  const [error, setError] = useState(null);

  // Fetch Categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://admin.rosenwell.com/categories');
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  // Fetch Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://admin.rosenwell.com/products');
        setProducts(response.data);
        console.log(response.data)
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('category', category);  // Sending the category ObjectId here
    formData.append('Therapy', Therapy);
    formData.append('details', details);
    formData.append('Form', Form);
    formData.append('Benefits', Benefits);
    formData.append('Packing', Packing);
    formData.append('Dosage', Dosage);
    formData.append('Disclaimer', Disclaimer);


    

    if (image) {
      formData.append('image', image);
    }

    try {
      if (selectedProductId) {
        // Update Product
        await axios.put(`https://admin.rosenwell.com/products/${selectedProductId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        alert('Product updated successfully');
      } else {
        // Add Product
        await axios.post('https://admin.rosenwell.com/products', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        alert('Product added successfully');
      }
      setSelectedProductId('');
      setName('');
      setDescription('');
      setCategory('');  // Reset category after submission
      setDetails('');
      setForm('');
      setBenefits('');
      setPacking('');
      setDosage('');
      setDisclaimer('');
      setTherapy('');
      setImage(null);
    } catch (error) {
      console.error('Error submitting product:', error);
      setError('Failed to submit product');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (productId) => {
    try {
      await axios.delete(`https://admin.rosenwell.com/products/${productId}`);
      alert('Product deleted successfully');
      setProducts(products.filter((product) => product._id !== productId));
    } catch (error) {
      console.error('Error deleting product:', error);
      setError('Failed to delete product');
    }
  };

  const handleSelectProduct = (product) => {
    setSelectedProductId(product._id);
    setName(product.name);
    setDescription(product.description);
    setCategory(product.category._id); // Set category based on the product's category reference
    setDetails(product.details);
    setTherapy(product.Therapy);  // Fix capitalization
    setForm(product.Form);
    setBenefits(product.Benefits);
    setPacking(product.Packing);
    setDosage(product.Dosage);
    setDisclaimer(product.Disclaimer);
  };
  

  return (
    <div>
      
      <h2 style={{ textAlign: "center", color: "#333" }}>Product Management</h2>
<form onSubmit={handleSubmit} style={{ maxWidth: "400px", margin: "auto", padding: "20px", border: "1px solid #ccc", borderRadius: "8px", boxShadow: "2px 2px 10px rgba(0,0,0,0.1)" }}>
  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Name</label>
    <input
      type="text"
      value={name}
      onChange={(e) => setName(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    />
  </div>

  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Description</label>
    <textarea
      value={description}
      onChange={(e) => setDescription(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", minHeight: "80px" }}
    />
  </div>

  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Category</label>
    <select
      value={category}
      onChange={(e) => setCategory(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    >
      <option value="">Select Category</option>
      {categories.map((category) => (
        <option key={category._id} value={category._id}>
          {category.name}
        </option>
      ))}
    </select>
  </div>

  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Ingredients</label>
    <input
      type="text"
      value={details}
      onChange={(e) => setDetails(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    />
  </div>
  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Therapy</label>
    <input
      type="text"
      value={Therapy}
      onChange={(e) => setTherapy(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    />
  </div>
  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Form</label>
    <input
      type="text"
      value={Form}
      onChange={(e) => setForm(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    />
  </div>
  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Benefits</label>
    <input
      type="text"
      value={Benefits}
      onChange={(e) => setBenefits(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    />
  </div>
  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Packing</label>
    <input
      type="text"
      value={Packing}
      onChange={(e) => setPacking(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    />
  </div>
  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Dosage</label>
    <input
      type="text" 
      value={Dosage}
      onChange={(e) => setDosage(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    />
  </div>
  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Disclaimer</label>
    <input
      type="text" 
      value={Disclaimer}
      onChange={(e) => setDisclaimer(e.target.value)}
      required
      style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
    />
  </div>

  <div style={{ marginBottom: "15px" }}>
    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>Image</label>
    <input type="file" accept="image/*" onChange={handleImageChange} style={{ width: "100%" }} />
  </div>

  <button
    type="submit"
    disabled={loading}
    style={{
      width: "100%",
      padding: "10px",
      backgroundColor: loading ? "#888" : "#007bff",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
    }}
  >
    {loading ? (selectedProductId ? "Updating..." : "Adding...") : selectedProductId ? "Update Product" : "Add Product"}
  </button>
</form>


      {error && <div style={{ color: 'red' }}>{error}</div>}

      <h3>Product List</h3>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Category</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product._id}>
              <td>{product.name}</td>
              <td>{product.description}</td>
              <td>
                {
                  categories.find((category) => category._id === product.category._id)?.name ||
                  'Unknown'
                }
              </td>
              <td>
                {product.image && (
                  <img
                    src={`https://admin.rosenwell.com${product.image}`}
                    alt={product.name}
                    style={{ width: '50px', height: '50px', margin: '5px' }}
                  />
                )}
              </td>
              <td>
                <button onClick={() => handleSelectProduct(product)}>Edit</button>
                <button onClick={() => handleDelete(product._id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductManagement;
